import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">

        {/* LEFT */}
        <div className="footer__brand">
          <h3 className="footer__title">Forosho Insights</h3>
          <p className="footer__subtitle">
            Learn AI, improve your health, and master your money — one smart step at a time.
          </p>
        </div>

        {/* LINKS */}
        <div className="footer__links">
          <h4>Explore</h4>
          <ul>
            <li><Link to="/">AI & Tech Today</Link></li>
            <li><a href="https://betterbodymind.com" target="_blank" rel="noreferrer">Better Body & Mind</a></li>
          </ul>
        </div>

        <div className="footer__links">
          <h4>Privacy Policy</h4>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/affiliate-disclosure">Affiliate Disclosure </Link></li>
            <li><Link to="/terms">Terms agreement</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* SOCIAL OPTIONAL */}
        <div className="footer__social">
          <h4>Connect</h4>
          <ul>
            <li><a href="https://www.youtube.com/@Forosho89" target="_blank" rel="noreferrer">YouTube</a></li>
            <li><a href="https://www.github.com/Forosho89" target="_blank" rel="noreferrer">GitHub</a></li>
          </ul>
        </div>

      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Forosho Insights. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;